import { PreferencesData } from '@beat-venues/common-types';
import { create } from 'zustand';

interface PreferencesState {
    preferences: PreferencesData[];
    setPreferences: (preferences: PreferencesData[]) => void;
}

export const usePreferencesStore = create<PreferencesState>((set) => ({
    preferences: [],
    setPreferences: (preferences) => set({ preferences: preferences }),
}));
